import React, { Component } from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Button, Card, Col, DatePicker, Divider, Drawer, notification, Row } from 'antd'
import { hideLoader, showLoader } from '../../../modules/actions'

import Request from '../../../request'
import { connect } from 'react-redux'


// const Option = Select.Option


class ApplicationMailer extends Component {
  state = {

    partArr: [],
    mailArr: [],
    showPart: false,
    channelPartnerId: null,
    visible: true,
    skip: true,
    mailBody: null,
    mediaArr: [],
    offerExpDate: null

  }

  componentDidMount = async () => {


    const { courseId, studentName } = this.props
    if (courseId) {
      let x = await Request.getUniversityContacts({ courseId })

      if (x && x.success) {
        this.setState({ mailArr: x.doc })
      }

    }

    let y = await Request.getUniversityMailTemplate({ studentName })
    if (y && y.success) {
      this.setState({ mailBody: y.doc && y.doc.templateData })
    }

    // this.loadDocs(inquiryId)

  }

  loadDocs = async (inquiryId) => {
    let y = await Request.studentMediaList({ _id: inquiryId })
    if (y && y.success) {

      _.each(y.arr, (v) => {
        v.check = true
      })
      this.setState({ mediaArr: y.arr })
    }

  }

  save = async () => {


    const { dispatch } = this.props
    let obj = {
      ...this.state
    }

    if (obj.showPart) {


      delete obj.mailArr
      if (!obj.channelPartnerId) {
        return notification.warning({
          message: 'Choose Channel Partner'
        })
      }
    } else {

      // obj.mailArr = _.filter(obj.mailArr, x => x.check)
      // if (!obj.mailArr.length) {
      //   return notification.warning({
      //     message: 'Choose University Email Address'
      //   })
      // }

    }


    if (!obj.offerExpDate) {
      return notification.warning({
        message: 'Choose Offer Expect Date'
      })
    }
    if (!obj.offerExpDate) {
      return notification.warning({
        message: 'Choose Offer Expect Date'
      })
    }


    obj.mediaArr = _.filter(obj.mediaArr, x => x.check)

    delete obj.partArr


    obj.inquiryId = this.props.inquiryId
    obj.courseId = this.props.courseId

    dispatch(showLoader())
    let x = await Request.saveApplicationMail(obj)
    dispatch(hideLoader())
    if (x && x.success) {
      this.onClose()
      return notification.success({
        message: x.msg
      })

    } else {
      return notification.error({
        message: 'Try again'
      })
    }

  }


  show = () => {

    this.setState({ visible: true })
  }
  onClose = () => {
    this.setState({
      visible: false
    })
    this.props.onClose()
  }
  callback = value => {

    this.props.callback()
  }


  render() {
    /*const columns = [
      {
        title: 'File Name',
        key: 'fileName',
        dataindex: 'fileName',
        width: 100,

      },
      {
        title: 'File Description',
        key: 'fileDescription',
        dataindex: 'fileDescription',
        width: 200,
      }

    ]*/
    return (
      <Drawer
        // title={`Send Email To ${showPart ? 'Partner' : 'University'}`}
        title={'Offer Expected Date'}
        placement={'right'}
        width={1000}
        closable={true}
        onClose={this.onClose}
        visible={this.state.visible}>
        <div>

          {/*<Card>
            <Row>
              <Col span={8}>
                <Radio.Group defaultValue="University" onChange={(e) => {
                  if (e.target.value == 'Partner') {
                    _.each(mailArr, (vvv) => {
                      vvv.check = false
                    })
                    return this.setState({ showPart: true, mailArr })
                  } else {
                    return this.setState({ showPart: false, channelPartnerId: null })
                  }
                }}>
                  <Radio.Button value="University">University</Radio.Button>
                  <Radio.Button value="Partner">Channel Partner</Radio.Button>
                </Radio.Group>
              </Col>


            </Row>

          </Card>
          <Card>
            <Row>
              <Col span={8}>
                {
                  showPart ? <div>
                    <h4>CHOOSE CHANNEL PARTNER</h4>
                    <Select
                      allowClear
                      showSearch={true}
                      style={{ width: 200 }}
                      placeHolder={'Choose Partner'}
                      value={this.state.channelPartnerId}
                      placeholder="Select Partner"
                      optionFilterProp="channelPartnerName"
                      onChange={(v) => {
                        this.setState({ channelPartnerId: v }, () => {

                        })
                      }}
                      filterOption={(input, option) => {
                        return (
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        )
                      }}>
                      {partArr.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>
                            {val.channelPartnerName}
                          </Option>
                        )
                      })}
                    </Select></div> : <div>
                    <h4>CHOOSE EMAIL ADDRESS</h4>
                    {
                      mailArr.map((vv, ii) => {
                        return (
                          <div key={ii}>
                            <Checkbox checked={vv.check} onChange={() => {
                              _.each(mailArr, (vsd, indexx) => {
                                if (indexx == ii) {
                                  vsd.check = !vsd.check
                                }
                              })
                              this.setState({ mailArr })


                              //vv.check = !v.target.value
                            }}/> {vv.mail}
                          </div>
                        )
                      })
                    }

                  </div>
                }


              </Col>
            </Row>

          </Card>*/}
          <Card>
            <Row>
              {/* <Col span={16}>
                {
                  mailBody ? <ReactQuill value={this.state.mailBody}/> : null
                }
              </Col>*/}

              <Col span={24} style={{ paddingLeft: 10, border: 1 }}>

                {/*   <div>
                  {mediaArr && mediaArr.length ? <h4>CHOOSE DOCUMENTS</h4> : null}
                  {
                    mediaArr.map((vv, ii) => {
                      return (
                        <div key={ii} style={{ marginBottom: 10 }}>
                          <Checkbox checked={vv.check} onChange={(v) => {

                            _.each(mediaArr, (vsd, indexx) => {
                              if (indexx == ii) {
                                vsd.check = !vsd.check
                              }
                            })
                            this.setState({ mediaArr })
                          }}/> {vv.fileName}
                          <div>{vv.description}</div>
                        </div>
                      )
                    })
                  }
                </div>
                <Divider/>*/}

                <div>
                  <h4>OFFER EXPECTED DATE</h4>
                  <DatePicker format={'DD-MMM-YYYY'}
                    disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
                    onChange={(v) => {
                      this.setState({ offerExpDate: v })
                    }}
                  />
                </div>
                <Divider />
                {/* <div>
                  <Checkbox value={skip} onChange={(v) => {
                    this.setState({ skip: !v.target.value })

                  }}/> Skip Mail
                </div>
             <Divider/>
              */}

                <Row>
                  <Col span={12}><Button type={'primary'} loading={this.props.loading}
                    onClick={() => this.save()}>
                    SAVE {/*{!skip ? '  & SEND ' : ' ONLY'}*/}</Button></Col>
                  {/*  <Col span={12}><Button type={'warning'} icon={'carry-out'}>Add Follow Up</Button></Col>*/}

                </Row>
              </Col>

            </Row>


          </Card>


        </div>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,

  categories: global.categories,
  search: router.location.search
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationMailer)
